import React from 'react';
import { PANEL_FORM_DIALOG_TEXT } from '../../../../../lang';

export const AddApplicationDialogContent = ({
  applicantSearch,
  applicantName,
}: {
  applicantSearch: number | '';
  applicantName: string;
}): React.ReactNode => (
  <div className="bg-white border border-[#DFDFDF] mx-4 flex flex-col justify-center items-center p-4">
    <p className="text-[#951D1D] font-semibold">
      {PANEL_FORM_DIALOG_TEXT.CONFIRM_ADD}
    </p>
    <div className="grid grid-cols-2 gap-4 py-4 text-md">
      <div className="flex flex-wrap">
        <p className="font-semibold">
          {PANEL_FORM_DIALOG_TEXT.APPLICATION_NO}:
        </p>
        &nbsp;
        {applicantSearch}
      </div>
      <div className="flex flex-wrap">
        <p className="font-semibold">
          {PANEL_FORM_DIALOG_TEXT.APPLICATION_NAME}:
        </p>
        &nbsp;
        {applicantName}
      </div>
    </div>
  </div>
);
